<template>
  <MenuGlobalItemSection>
    <DropdownMenuWidget :dropdown-menu-list="profileMenu">
      <DropdownWorkspaceItemSection/>
    </DropdownMenuWidget>
  </MenuGlobalItemSection>

</template>
<script lang="ts">
import {defineComponent} from 'vue'
import {DropdownMenuWidget} from '@shared/components/widgets/dropdowns'
import {DropdownWorkspaceItemSection, MenuGlobalItemSection} from '@shared/components/sections'
import {AccountNs, AuthenticationNs, SettingNs} from "@shared/types";
import {isWsOwnerOrAdmin} from "@shared/mixins/role-manager";


export default defineComponent({
  name: 'MenuGlobalWidget',
  components: {
    DropdownMenuWidget,
    MenuGlobalItemSection,
    DropdownWorkspaceItemSection
  },
  data() {
    const profileMenu = [] as any[]
    profileMenu.push({slotName: 'DropdownWorkspaceItemSection', hasDivider: true})
    if (isWsOwnerOrAdmin()) {
      profileMenu.push({
        path: SettingNs.SettingRouteEnums.UPGRADE,
        label: 'Upgrade',
        showPackageLabel: true,
        hasDivider: true
      })
    }
    profileMenu.push({path: AccountNs.AccountRouteEnums.PROFILE, label: 'Account'})
    profileMenu.push({
      path: SettingNs.SettingRouteEnums.THEMES,
      label: 'Settings',
      hasDivider: true
    })
    profileMenu.push({
      path: AuthenticationNs.AuthenticationRouteEnums.Logout,
      label: 'Sign Out',
      icon: 'LogOut'
    })

    return {
      profileMenu
    }
  }
})

</script>
